import { createSelector } from '@reduxjs/toolkit';
// Types
import Reducers from 'app/types/Reducers';
// Models
import { RootState } from 'app/store';
import { IPushAlert } from './AppUINotifications.slice';

export const selectSnackbars = (state:RootState) => state[Reducers.AppUINotifications].snackbars;
export const selectSystemMessages = (state:RootState) => state[Reducers.AppUINotifications].systemMessages;
export const selectPushAlerts = (state:RootState) => state[Reducers.AppUINotifications].pushAlerts;

type IPushAlerts = RootState[Reducers.AppUINotifications]['pushAlerts'];

type PushAlertProps<K extends keyof IPushAlerts = keyof IPushAlerts> = 
  K extends keyof IPushAlerts
    ? {
        category: K;
        type: keyof IPushAlerts[K];
      }
    : never;

export const selectPushAlert = createSelector(
  [
    selectPushAlerts,
    (_: any, props: PushAlertProps) => props,
  ],
  (pushAlerts: IPushAlerts, { category, type }: PushAlertProps) => {
    return (pushAlerts[category] as Record<string, IPushAlert | null>)[type];
  }
);
